import React from 'react';
import AlreadyHaveAccountSection from './AlreadyHaveAccountSection';
import ResponsibleGambling from '../ResponsibleGambling';
import { useScreenQuery } from 'playup-web-core';
import styled from 'styled-components';
import appConfig from '../../../appConfig';

const SignUpFooter = ({ showRG }: SignUpFooterProps) => {
	const { isSmall } = useScreenQuery();

	return (
		<>
			<AlreadyHaveAccountSection isSmallScreen={isSmall} />
			<AcknowledgementText isSmallScreen={isSmall}>
				By clicking "Create Account", I acknowledge that I am over 18 and have read, understood and agree to be bound by
				the {appConfig.brand.name}{' '}
				<Terms isSmallScreen={isSmall} href={appConfig.brand.urls.terms} target="_blank" rel="noreferrer">
					Terms & Conditions
				</Terms>{' '}
				and{' '}
				<Terms isSmallScreen={isSmall} href={appConfig.brand.urls.privacy_policy} target="_blank" rel="noreferrer">
					Privacy Policy
				</Terms>
				. I also agree to receive promotional material from ${appConfig.brand.company} via email, SMS, phone and other
				direct means.
			</AcknowledgementText>
			{showRG && <ResponsibleGambling />}
		</>
	);
};

export default SignUpFooter;

interface SignUpFooterProps {
	showRG?: boolean;
}
const AcknowledgementText = styled.p<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	color: theme.colors.darkR,
	fontSize: isSmallScreen ? '10px' : '12px',
	margin: isSmallScreen ? '15px 0' : '30px 0',
	lineHeight: '12px',
	marginTop: '0px',
}));

const Terms = styled.a<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	textDecoration: 'underline',
	color: theme.colors.darkR,
	fontSize: isSmallScreen ? '8px' : '10px',
}));
